
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/blog",
      function () {
        return require("private-next-pages/site/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/blog"])
      });
    }
  